export const trackPageAction = (...args) => {
  if (!window.PTCWebTracking) return
  window.PTCWebTracking.TrackPageAction(document.title, ...args)
}

export const trackPageView = () => {
  if (!window.PTCWebTracking) return
  window.PTCWebTracking.TrackPageView(document.title)
}
